import React  from 'react';
import {withRouter} from "react-router-dom"
import { TitleXl, BodySm, Row, Col4} from "components/elements";
import {OtherNewsLettersWrapper, TitleXlContainer, BodySmContainer} from './elements';
import Newsletters from 'components/Newsletters';



function ExploreOtherNewsletters() {

    return(
        <OtherNewsLettersWrapper>
             <TitleXlContainer>
                <TitleXl color="#000" fontWeight="900">Explore our newsletters </TitleXl>
            </TitleXlContainer>
            <BodySmContainer>
                <BodySm color="#000" >Subscribe to our monthly Healthcare Connection for a wide-ranging look at how AI and ideas are transforming healthcare. Or go deep with our specialized newsletters on pricing & access and health equity.</BodySm>
            </BodySmContainer>
              <Row>
                <Col4>
                <Newsletters link="/healthcare-connection" title={"The Healthcare Connection"} intro={"A monthly roundup of the people, stories and ideas that are changing healthcare for the better."} image={"/images/Healthcare_Connection_Thumb.png"}  />
                </Col4>
                <Col4>
                <Newsletters link="/health-equity-digest" title={"Health Equity Digest"} intro={"Insights, education and analytics at the intersection of public health and health equity. Delivered once a month."} image={"/images/Health_Equity_thumb.png"}   />
                </Col4>
                <Col4>
                <Newsletters link="/weekly-value-newsletter" title={"Weekly Value Report"} intro={"A weekly round-up and analysis of biopharma pricing and value news."} image={"/images/Value_Report_Thumb.png"}   />
                </Col4>
              </Row>
         </OtherNewsLettersWrapper>
    )
}

export default withRouter(ExploreOtherNewsletters);
